module.exports = __webpack_public_path__ + "img/LAL_login_LOGO_B.af007244.svg";